import axios from "axios";
import { takeLatest, call, put, select } from "redux-saga/effects";
import { createAction } from "redux-actions";
import { queryParams } from "../../../../utils/queryParams";
import { getBaseUrlParams } from "../../../../utils/getBaseUrlParams";

export const FETCH_MODULES_DATA_SUCCESS = "saga/FETCH_MODULES_DATA_SUCCESS";
export const FETCH_MODULES_DATA = "saga/FETCH_MODULES_DATA";

export const UPDATE_PREFERENCES_SUCCESS = "saga/UPDATE_PREFERENCES_SUCCESS";
export const UPDATE_PREFERENCES = "saga/UPDATE_PREFERENCES";

export const SET_PAGE_LOADING = "saga/SET_PAGE_LOADING";
export const SET_PAGE_NAME = "saga/SET_PAGE_NAME";

export const CHANGE_CONFIGURATOR_DISPLAY_NAME = "saga/CHANGE_CONFIGURATOR_DISPLAY_NAME";

function toSnakeCase(pageName) {
  return pageName
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");
}

export const actionCreators = {
  fetchModulesData: createAction(FETCH_MODULES_DATA),
  updatePreferences: createAction(UPDATE_PREFERENCES)
};

export default function* watchCheckIn() {
  yield takeLatest(FETCH_MODULES_DATA, fetchModulesData);
  yield takeLatest(UPDATE_PREFERENCES, updatePreferences);
}

export function* fetchModulesData({ payload }) {
  const { pageName } = payload;
  const { short_url, organization_id } = yield getBaseUrlParams();
  yield put({ type: SET_PAGE_LOADING, payload: true });
  yield put({ type: SET_PAGE_NAME, payload: pageName });
  try {
    const { data } = yield call(axios.get, queryParams.apiVersion + `settings/pages`, {
      params: {
        page: toSnakeCase(payload.pageName),
        short_url,
        organization_id
      }
    });

    yield put({ type: FETCH_MODULES_DATA_SUCCESS, payload: data.preload_page });
    yield put({ type: SET_PAGE_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

export function* updatePreferences({ payload }) {
  const pageName = yield select((state) => state.commonReducer.pageName);
  const { short_url, organization_id } = yield select((state) => state.commonReducer.commonProps);
  try {
    const { data } = yield call(axios.put, queryParams.apiVersion + "settings/pages", {
      page_modules: payload.map((pref) => pref.name),
      page: toSnakeCase(pageName),
      organization_id: organization_id.toString(),
      short_url
    });

    yield put({ type: UPDATE_PREFERENCES_SUCCESS, payload: data.preferences });
  } catch (error) {
    console.error(error);
  }
}
